import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import Index from "./pages/Index";
import { Header, Footer } from "./layout";

function App() {
  const queryClient: QueryClient = new QueryClient();
  return (
    <QueryClientProvider client={queryClient}>
      <Header />
      <BrowserRouter basename={process.env.REACT_APP_PATH || ""}>
        <Routes>
          <Route path="*" element={<Index />} />
        </Routes>
      </BrowserRouter>
      <Footer />
    </QueryClientProvider>
  );
}

export default App;
